<template lang="pug">
#pageTable
  v-container(grid-list-xl, fluid, style="min-height: calc(100vh - 64px - 50px)")
    v-layout(row, wrap)
      v-flex(md12, xs12).pa-0.mt-0
        v-card.elevation-1
          v-card-text.pb-2
            v-layout(row, wrap, align-center).mb-2
              v-flex.shrink
                span.subheading.font-weight-medium.grey--text.text--darken-2 Período
              v-flex.shrink.ml-2
                v-btn(small, flat, color="success", @click="setData(0, 0)") Mês Atual
              v-flex.shrink
                v-btn(small, flat, color="success", @click="setData(1, 0)") Mês Anterior
              v-flex.shrink
                v-btn(small, flat, color="success", @click="setData(2, 0)") Últimos 3 meses
              v-flex.shrink
                v-btn(small, flat, color="success", @click="setData(5, 0)") Últimos 6 meses

            v-divider.mb-3

            v-layout(row, wrap, align-center)
              v-flex.md2
                v-menu(v-model="menuDataInicial", :close-on-content-click="false", :nudge-right="40", lazy, transition="scale-transition", offset-y, full-width, min-width="290px")
                  template(v-slot:activator="{ on }")
                    v-text-field(:value="dataInicialFormatada", label="Data de Início", v-on="on", readonly, prepend-icon="event", hide-details)
                  v-date-picker(v-model="filtro.data_inicial", @input="menuDataInicial = false")
              v-flex.md2
                v-menu(v-model="menuDataFinal", :close-on-content-click="false", :nudge-right="40", lazy, transition="scale-transition", offset-y, full-width, min-width="290px")
                  template(v-slot:activator="{ on }")
                    v-text-field(:value="dataFinalFormatada", label="Data de Fim", v-on="on", readonly, prepend-icon="event", hide-details)
                  v-date-picker(v-model="filtro.data_final", @input="menuDataFinal = false")
              v-flex.md3
                v-autocomplete(label="Questionário", :items="listQuestionarios", :disabled="!listQuestionarios.length", item-text="nome", item-value="id", color="primary", v-model="filtro.questionario_id", :clearable="true", :autocomplete="false", :filter="customFilter", prepend-icon="assignment", hide-details, placeholder="Selecione o questionário")
              v-flex.md2
                v-autocomplete(label="Auditado", :items="listAuditados", :disabled="!listAuditados.length", item-text="nome", item-value="id", color="primary", v-model="filtro.auditado_id", :clearable="true", :autocomplete="false", :filter="customFilter", prepend-icon="business", hide-details, placeholder="Todos")
              v-flex.md2
                v-select(label="Status da Revisão", :items="listStatus", item-text="nome", item-value="id", color="primary", v-model="filtro.resultado_valor_status", :clearable="true", prepend-icon="fact_check", hide-details, placeholder="Todos")
              v-flex.md1.text-xs-center
                v-btn(color="primary", :loading='loading', :disabled="!filtro.questionario_id", @click="getData()", block).white--text.mt-3 Aplicar

        v-card(v-if="sumarioGeral && !loadingRelatorio").elevation-1.mt-3
          v-card-text.pa-4
            v-layout(row, align-start)
              v-flex(style="flex:0 0 40%; max-width:40%;")
                div(style="display:flex; align-items:center; gap:8px; margin-bottom:10px;")
                  div(style="width:3px; height:14px; background:#90a4ae; border-radius:2px;")
                  span.caption.font-weight-bold.grey--text.text--darken-2(style="letter-spacing:.1em; text-transform:uppercase;") Documentos
                v-layout(row)
                  v-flex.pr-2(style="min-width:200px;")
                    v-card.elevation-0.totalizador-card(style="border-left: 4px solid #e53935; background: #fff8f8; border-radius:6px;")
                      v-card-text.pa-3
                        v-layout(row, align-center)
                          v-flex
                            div(style="font-size:28px; font-weight:700; line-height:1;").red--text.text--darken-1 {{ sumarioGeral.vencidos }}
                            div.caption.grey--text.text--darken-1(style="margin-top:6px;") Vencidos
                          v-flex.shrink
                            v-icon(color="red darken-1", size="36") event_busy
                  v-flex(style="min-width:200px;")
                    v-card.elevation-0.totalizador-card(style="border-left: 4px solid #1976d2; background: #f3f8ff; border-radius:6px;")
                      v-card-text.pa-3
                        v-layout(row, align-center)
                          v-flex
                            div(style="font-size:28px; font-weight:700; line-height:1;").blue--text.text--darken-2 {{ sumarioGeral.vigentes }}
                            div.caption.grey--text.text--darken-1(style="margin-top:6px;") Vigentes
                          v-flex.shrink
                            v-icon(color="blue darken-2", size="36") event_available
              v-divider(vertical).mx-4
              v-flex(style="flex:2;")
                div(style="display:flex; align-items:center; gap:8px; margin-bottom:10px;")
                  div(style="width:3px; height:14px; background:#90a4ae; border-radius:2px;")
                  span.caption.font-weight-bold.grey--text.text--darken-2(style="letter-spacing:.1em; text-transform:uppercase;") Questões
                v-layout(row)
                  v-flex.pr-2(style="min-width:200px;")
                    v-card.elevation-0.totalizador-card(style="border-left: 4px solid #f57c00; background: #fffaf3; border-radius:6px;")
                      v-card-text.pa-3
                        v-layout(row, align-center)
                          v-flex
                            div(style="font-size:28px; font-weight:700; line-height:1;").orange--text.text--darken-2 {{ sumarioGeral.statusCount.aguardando }}
                            div.caption.grey--text.text--darken-1(style="margin-top:6px;") Aguardando Revisão
                          v-flex.shrink
                            v-icon(color="orange darken-2", size="36") hourglass_empty
                  v-flex.pr-2(style="min-width:200px;")
                    v-card.elevation-0.totalizador-card(style="border-left: 4px solid #388e3c; background: #f4fff4; border-radius:6px;")
                      v-card-text.pa-3
                        v-layout(row, align-center)
                          v-flex
                            div(style="font-size:28px; font-weight:700; line-height:1;").green--text.text--darken-2 {{ sumarioGeral.statusCount.valido }}
                            div.caption.grey--text.text--darken-1(style="margin-top:6px;") Válidos
                          v-flex.shrink
                            v-icon(color="green darken-2", size="36") check_circle
                  v-flex(style="min-width:200px;")
                    v-card.elevation-0.totalizador-card(style="border-left: 4px solid #c62828; background: #fff5f5; border-radius:6px;")
                      v-card-text.pa-3
                        v-layout(row, align-center)
                          v-flex
                            div(style="font-size:28px; font-weight:700; line-height:1;").red--text.text--darken-3 {{ sumarioGeral.statusCount.invalido }}
                            div.caption.grey--text.text--darken-1(style="margin-top:6px;") Inválidos
                          v-flex.shrink
                            v-icon(color="red darken-3", size="36") cancel

      v-flex(md12, xs12).pa-0.mt-3
        v-card(v-if="loadingRelatorio").elevation-0(color="transparent")
          v-card-text.text-xs-center.py-5
            v-progress-circular(:width="3", :size="48", color="primary", indeterminate).mb-3
            p.subheading.grey--text.mb-0 Carregando informações...

        v-card(v-if="dadosBar && !loadingRelatorio").elevation-1
          v-tabs(v-model="tab", slider-color="primary")
            v-tabs-slider(color='primary')
            v-tab(:key="0").black--text
              v-icon(color="black", size="18", left) table_rows
              | Tabela
            v-tab(:key="1").black--text
              v-icon(color="black", size="18", left) description
              | Documentos

            v-tab-item(:key="0")
              v-card-text.pa-3
                v-data-table(:headers='headersRespostas', :items='dadosPorAuditado', :rows-per-page-items="[25,50,75,{text:'Todos','value':-1}]").elevation-0
                  template(slot='items', slot-scope='props')
                    td(width="5%").text-xs-center {{ props.item.idQuestao }}
                    td(width="30%").text-xs-left {{ props.item.nomeQuestao }}
                    td(width="30%")
                      BoxChart(
                        :type="'horizontal-bar'"
                        :chartColor="['#F5C343', '#4caf50', '#f44336', '#FCFABC']"
                        :data="props.item.opcoes"
                        :legend="false"
                      )
                    td.text-xs-center
                      v-btn(v-if="props.item.countFeedbacks", small, color="black", flat, @click="openDialogFeedbacks(props.item.feedbacks)").primary--text.caption.pa-0.mx-0.my-0.ma-0 Detalhes ({{ props.item.countFeedbacks }})
                      span(v-else).grey--text.caption Nenhum feedback

            v-tab-item(:key="1")
              v-card-text.pa-0
                div(v-if="!documentosAgrupados.length").text-xs-center.grey--text.py-5 Nenhum documento encontrado
                table(v-else, style="width:100%; border-collapse:collapse;")
                  thead
                    tr(style="height:56px; border-bottom:1px solid rgba(0,0,0,.12);")
                      th.text-xs-left(style="padding:0 16px 0 24px; font-size:12px; font-weight:500; color:rgba(0,0,0,.54); width:30%;") Questão
                      th.text-xs-left(style="padding:0 16px 0 0; font-size:12px; font-weight:500; color:rgba(0,0,0,.54);") Documentos
                      th.text-xs-right(style="padding:0 24px 0 0; font-size:12px; font-weight:500; color:rgba(0,0,0,.54); width:150px; white-space:nowrap;") Status
                  tbody
                    template(v-for="grupo in documentosAgrupados")
                      tr(
                        v-for="(questao, qi) in grupo.questoes",
                        :key="grupo.auditoria_id + '_' + qi",
                        style="border-top:1px solid #e8e8e8; vertical-align:middle;"
                      )
                        td(style="padding:16px 20px 16px 24px; vertical-align:top; width:30%;")
                          div.body-2.font-weight-medium(style="line-height:1.4; margin-bottom:10px;") {{ questao.questao_texto }}
                          div(style="display:flex; align-items:center; gap:6px; margin-bottom:4px;")
                            v-icon(size="13", color="grey lighten-1") business
                            span.caption.grey--text.text--darken-1.font-weight-medium {{ grupo.auditado_identificador }}
                            span.caption.grey--text · {{ grupo.auditado_nome }}
                          div(style="display:flex; align-items:center; gap:6px;")
                            v-icon(size="13", color="grey lighten-1") assignment
                            span.caption.grey--text {{ grupo.questionario_nome }}
                            span.caption.grey--text.text--lighten-1(v-if="grupo.questionario_tipo_nome") · {{ grupo.questionario_tipo_nome }}
                        td(style="padding:16px 20px 16px 0; vertical-align:middle;")
                          div(style="display:flex; flex-wrap:wrap; gap:8px;")
                            v-tooltip(v-for="doc in questao.documentos", :key="doc.id", top)
                              v-chip(
                                slot="activator",
                                small,
                                :color="isVencido(doc.data_vencimento) ? 'red lighten-4' : doc.data_vencimento ? 'blue lighten-5' : 'grey lighten-3'",
                                :text-color="isVencido(doc.data_vencimento) ? 'red darken-2' : doc.data_vencimento ? 'blue darken-1' : 'grey darken-1'",
                                :disabled="!doc.arquivo",
                                @click="doc.arquivo && abrirDocumento(doc)",
                                style="cursor:pointer;"
                              )
                                v-icon(left, small) attach_file
                                | {{ doc.nome_original || 'Sem nome' }}
                              div(slot="default", style="line-height:1.6;")
                                div
                                  span(style="opacity:.7;") Emissão:
                                  strong {{ doc.data_emissao ? $moment(doc.data_emissao).format('DD/MM/YYYY') : 'Não informada' }}
                                div
                                  span(style="opacity:.7;") Vencimento:
                                  strong(:style="isVencido(doc.data_vencimento) ? 'color:#ff8a80;' : ''") {{ doc.data_vencimento ? $moment(doc.data_vencimento).format('DD/MM/YYYY') : 'Não informado' }}
                                div(v-if="doc.data_vencimento")
                                  strong(:style="isVencido(doc.data_vencimento) ? 'color:#ff8a80;' : 'color:#90caf9;'") {{ isVencido(doc.data_vencimento) ? 'Vencido' : 'Vigente' }}
                        td(style="padding:16px 24px 16px 0; vertical-align:middle; text-align:right; white-space:nowrap;")
                          v-chip(:color="getStatusColor(questao.resultado_status)", text-color="white", small).caption {{ questao.resultado_status | statusResultadoValor }}

    v-dialog(v-if="dialogPdfPreview", v-model="dialogPdfPreview", width="auto", scrollable, max-width="950px", persistent)
      v-card
        v-card-title.headline.grey.lighten-2
          v-layout(row, wrap, align-center)
            v-flex.xs8.sm9
              span.subheading.text-truncate {{ pdfPreviewAux && pdfPreviewAux.nome_original || 'Documento' }}
            v-flex.xs4.sm3.text-xs-right
              v-btn(flat, small, color="primary", :href="pdfPreviewUrl", target="_blank") Nova aba
              v-btn(icon, @click.native="dialogPdfPreview = false; pdfPreviewAux = null; pdfPreviewUrl = ''").pa-0.ma-0
                v-icon close
        v-card-text.pa-0
          iframe(:src="pdfPreviewUrl", style="width: 100%; max-width: 100%; height: 640px; border: none; display: block;")

    v-dialog(v-model="dialogFeedbacks", width="auto", scrollable, max-width="700px", persistent)
      v-card
        v-card-title.grey.lighten-2
          v-layout(row, wrap)
            v-flex.md11
              span.headline Detalhes dos feedbacks
            v-flex.md1.text-xs-right
              v-tooltip(top)
                v-btn(icon, slot="activator", @click.native="dialogFeedbacks = false; questaoFeedbacks = []").pa-0.mx-0.my-0.ma-0
                  v-icon close
                span Fechar
        v-divider
        v-card-text
          v-layout(row, wrap)
            v-flex(v-for="(categoria, index) in questaoFeedbacks", :key="index").md12
              v-layout(row, wrap).grey.lighten-3.pa-2
                v-flex.md10
                  span.font-weight-medium.subheading {{ categoria.nomeCategoria }}
                v-flex.md2.text-xs-right
                  span.font-weight-bold {{ categoria.qtdCategoria }}
              v-layout(row, wrap)
                v-flex(v-for="(feedback, index) in categoria.feedbacks", :key="index").md12
                  v-divider
                  v-layout(row, wrap).pa-2
                    v-flex.md10
                      span {{ feedback.nomeFeedback }}
                    v-flex.md2.text-xs-right
                      span {{ feedback.qtdFeedback }}
        v-divider
        v-card-actions.grey.lighten-2
          v-layout(row, wrap)
            v-flex.xs12.text-xs-right
              v-btn(color="black", flat, @click.native="dialogFeedbacks = false; questaoFeedbacks = []") Fechar

</template>

<script>
import _ from "lodash";
import BoxChart from "@/components/BoxChart";

export default {
    components: {
        BoxChart,
    },
    data() {
        return {
            filtro: {
                data_inicial: this.$moment().format("YYYY-MM-DD"),
                data_final: this.$moment().format("YYYY-MM-DD"),
                auditado_id: null,
                questionario_id: null,
                resultado_valor_status: null,
            },
            headersRespostas: [
                { text: "#", align: "center", value: "id" },
                { text: "Questão", align: "left", value: "texto" },
                { text: "Respostas", align: "left" },
                { text: "Feedbacks", align: "center", value: "countFeedbacks" },
            ],
            headersDocumentos: [
                { text: "Auditado", align: "left", value: "auditado_identificador" },
                { text: "Auditoria", align: "left", value: "questionario_nome" },
                { text: "Questão", align: "left", value: "questao_texto" },
                { text: "Documento", align: "left", value: "nome_original" },
                { text: "Emissão", align: "center", value: "data_emissao" },
                { text: "Vencimento", align: "center", value: "data_vencimento" },
                { text: "Status", align: "center", value: "resultado_status" },
            ],
            listStatus: [
                { id: 1, nome: "Aguardando Revisão" },
                { id: 2, nome: "Válido" },
                { id: 3, nome: "Inválido" },
            ],
            tab: 0,
            questoesAll: [],
            auditorias: [],
            auditados: [],
            listAuditados: [],
            listQuestionarios: [],
            listAuditorias: [],
            loading: false,
            messageEmpty: false,
            loadingRelatorio: false,
            loadingAuditados: false,
            loadingAuditorias: false,
            menuDataInicial: false,
            menuDataFinal: false,
            dadosBar: null,
            respostasPorAuditado: [],
            respostasPorAuditado2: [],
            respostasAll: [],
            questaoFeedbacks: [],
            dialogFeedbacks: false,
            documentos: [],
            sumario: null,
            questoesExpandidas: {},
            dialogPdfPreview: false,
            pdfPreviewAux: null,
            pdfPreviewUrl: '',
        };
    },
    computed: {
        dataInicialFormatada() {
            return this.filtro.data_inicial
                ? this.$moment(this.filtro.data_inicial).format("DD/MM/YYYY")
                : this.$moment().format("DD/MM/YYYY");
        },
        dataFinalFormatada() {
            return this.filtro.data_final
                ? this.$moment(this.filtro.data_final).format("DD/MM/YYYY")
                : this.$moment().format("DD/MM/YYYY");
        },
        dadosPorAuditado() {
            const vm = this;
            let respostasAll = _.cloneDeep(vm.respostasAll);
            let respostasPorAuditado2 = _.cloneDeep(vm.respostasPorAuditado2);
            if (!_.isNil(this.filtro.auditado_id)) {
                let aux = _.filter(respostasPorAuditado2, {
                    idAuditado: vm.filtro.auditado_id,
                });
                return aux;
            }
            return respostasAll;
        },
        documentosAgrupados() {
            const byAuditoria = _.groupBy(this.documentos, 'auditoria_id');
            return Object.values(byAuditoria).map(auditoriaDocs => {
                const byQuestao = _.groupBy(auditoriaDocs, 'questao_texto');
                const questoes = Object.values(byQuestao).map(docs => ({
                    questao_texto: docs[0].questao_texto,
                    resultado_status: docs[0].resultado_status,
                    documentos: docs,
                }));
                return {
                    auditoria_id: auditoriaDocs[0].auditoria_id,
                    auditado_nome: auditoriaDocs[0].auditado_nome,
                    auditado_identificador: auditoriaDocs[0].auditado_identificador,
                    questionario_nome: auditoriaDocs[0].questionario_nome,
                    questionario_tipo_nome: auditoriaDocs[0].questionario_tipo_nome,
                    questoes,
                };
            });
        },
        sumarioGeral() {
            if (!this.auditorias.length) return null;
            const hoje = this.$moment().startOf('day');
            const questoesUnicas = _.uniqBy(this.documentos, d => d.auditoria_id + '_' + d.questao_texto);
            return {
                vencidos: this.documentos.filter(d =>
                    d.data_vencimento && this.$moment(d.data_vencimento).isBefore(hoje, 'day')
                ).length,
                vigentes: this.documentos.filter(d =>
                    d.data_vencimento && !this.$moment(d.data_vencimento).isBefore(hoje, 'day')
                ).length,
                statusCount: {
                    aguardando: questoesUnicas.filter(d => d.resultado_status === 1).length,
                    valido: questoesUnicas.filter(d => d.resultado_status === 2).length,
                    invalido: questoesUnicas.filter(d => d.resultado_status === 3).length,
                },
            };
        },
    },
    mounted() {
        this.getQuestionarios();
        this.getAuditados();
    },
    methods: {
        getArquivoUrl(arquivo) {
            if (!arquivo) return '';
            return arquivo.startsWith('http') ? arquivo : 'https://' + arquivo;
        },
        isPdf(doc) {
            const mime = doc.tipo_arquivo || '';
            const url = doc.arquivo || '';
            return mime.includes('pdf') || url.toLowerCase().split('?')[0].endsWith('.pdf');
        },
        abrirDocumento(doc) {
            const url = this.getArquivoUrl(doc.arquivo);
            if (this.isPdf(doc)) {
                this.pdfPreviewAux = doc;
                this.pdfPreviewUrl = url;
                this.dialogPdfPreview = true;
            } else {
                window.open(url, '_blank');
            }
        },
        isVencido(dataVencimento) {
            if (!dataVencimento) return false;
            return this.$moment(dataVencimento).isBefore(this.$moment(), 'day');
        },
        getVencimentoClass(dataVencimento) {
            if (!dataVencimento) return '';
            return this.isVencido(dataVencimento) ? 'red--text text--darken-2 font-weight-medium' : 'green--text text--darken-2';
        },
        toggleQuestao(key) {
            this.$set(this.questoesExpandidas, key, this.questoesExpandidas[key] === false ? true : false);
        },
        getStatusColor(status) {
            if (status === 2) return '#318837';
            if (status === 3) return '#C9302C';
            return '#ec971f';
        },
        openDialogFeedbacks(feedbacks) {
            const vm = this;
            vm.dialogFeedbacks = true;
            vm.questaoFeedbacks = feedbacks;
        },
        setData(mesesInicio, mesesFinal) {
            const vm = this;
            vm.filtro.data_inicial = this.$moment()
                .subtract(mesesInicio, "month")
                .startOf("month")
                .format("YYYY-MM-DD");
            vm.filtro.data_final = this.$moment()
                .subtract(mesesFinal, "month")
                .endOf("month")
                .format("YYYY-MM-DD");
        },
        countRespostas(opcoes, questoes) {
            let total = questoes && questoes.length ? questoes.length : 0;
            let opcoesArray = [];
            let respostasArray = [];
            _.map(questoes, function (q) {
                _.map(q.opcoes_questao, function (o) {
                    opcoesArray.push(o);
                });
            });
            _.map(opcoes, function (o) {
                let quantidade = _.sumBy(opcoesArray, function (a) {
                    return a.idOpcao == o.idOpcao && a.quantidade == 1;
                });
                let porcentagem = parseFloat(
                    (quantidade / total) * 100,
                ).toFixed(1);
                respostasArray.push({
                    category: o.nomeOpcao,
                    value: parseInt(quantidade),
                    color: o.cor,
                });
            });
            return respostasArray;
        },
        getOpcoesPergunta(q) {
            let opcoesPergunta = [];
            _.map(q.opcoes_questao, function (o) {
                opcoesPergunta.push({
                    idOpcao: o.id,
                    nomeOpcao: o.texto,
                    cor: o.cor ? o.cor : "#4caf50",
                    quantidade:
                        q.resultado && q.resultado.opcao_questao_id == o.id
                            ? 1
                            : 0,
                });
            });
            return opcoesPergunta;
        },
        getOpcoes(questoes) {
            const vm = this;
            let questoesAll = [];
            let respostasQuestoes = [];
            _.map(questoes, function (q) {
                questoesAll.push({
                    idQuestao: q.id,
                    nomeQuestao: q.texto,
                    opcoes_questao: vm.getOpcoesPergunta(q),
                });
            });
            let groupByQuestoes = _.groupBy(questoesAll, "idQuestao");
            for (var prop in groupByQuestoes) {
                respostasQuestoes.push({
                    idQuestao: groupByQuestoes[prop][0].idQuestao,
                    nomeQuestao: groupByQuestoes[prop][0].nomeQuestao,
                    opcoes: vm.countRespostas(
                        groupByQuestoes[prop][0].opcoes_questao,
                        groupByQuestoes[prop],
                    ),
                    total: groupByQuestoes[prop].length,
                });
            }
            return respostasQuestoes;
        },
        async createData() {
            const vm = this;
            let respostasQuestoes = [];
            let arrayQuestoes = [];
            _.map(vm.auditorias, (auditoria) => {
                let filterResultado = _.filter(
                    auditoria.questoesAll,
                    "resultado",
                );
                vm.respostasPorAuditado.push({
                    idAuditoria: auditoria.idAuditoria,
                    idAuditado: auditoria.idAuditado,
                    nomeAuditado: auditoria.nomeAuditado,
                    questoesAll: filterResultado,
                    questoes: vm.getOpcoes(filterResultado),
                });
                vm.auditados.push({
                    idAuditado: auditoria.idAuditado,
                    nomeAuditado: auditoria.nomeAuditado,
                });
            });
            _.map(vm.respostasPorAuditado, (auditado) => {
                _.map(auditado.questoesAll, (questao) => {
                    arrayQuestoes.push({
                        idAuditado: auditado.idAuditado,
                        idQuestao: questao.id,
                        nomeQuestao: questao.texto,
                        opcoes_questao: vm.getOpcoesPergunta(questao),
                        questoesAll: auditado.questoesAll,
                        countFeedbacks: vm.countFeedbacks(questao),
                        feedbacks: vm.getFeedbacks(questao),
                    });
                });
            });
            vm.respostasPorAuditado2 = arrayQuestoes;
            let groupByQuestoes = _.groupBy(arrayQuestoes, "idQuestao");
            for (var prop in groupByQuestoes) {
                vm.respostasAll.push({
                    idAuditado: groupByQuestoes[prop][0].idAuditado,
                    idQuestao: groupByQuestoes[prop][0].idQuestao,
                    nomeQuestao: groupByQuestoes[prop][0].nomeQuestao,
                    opcoes: vm.countRespostas(
                        groupByQuestoes[prop][0].opcoes_questao,
                        groupByQuestoes[prop],
                    ),
                    total: groupByQuestoes[prop].length,
                    countFeedbacks: groupByQuestoes[prop][0].countFeedbacks,
                    feedbacks: groupByQuestoes[prop][0].feedbacks,
                });
            }
        },
        getFeedbacks(questao) {
            let arrayFeedbacks = [];
            let arrayAux = [];
            questao.resultados.map((resultado) => {
                resultado.anexos.map((anexo) => {
                    anexo.feedbacks_anexos.map((obj) => {
                        arrayFeedbacks.push(obj.feedback);
                    });
                });
            });
            let groupFeedbcksByCategoria = _.groupBy(
                arrayFeedbacks,
                "categoria_feedback_id",
            );
            for (let prop in groupFeedbcksByCategoria) {
                let groupFeedbcksById = _.groupBy(
                    groupFeedbcksByCategoria[prop],
                    "id",
                );
                let arrayFeedbacksById = [];
                for (let propFeedback in groupFeedbcksById) {
                    arrayFeedbacksById.push({
                        nomeFeedback: groupFeedbcksById[propFeedback][0].texto,
                        qtdFeedback: groupFeedbcksById[propFeedback].length,
                    });
                }
                arrayAux.push({
                    nomeCategoria:
                        groupFeedbcksByCategoria[prop][0].categoria_feedback
                            .texto,
                    qtdCategoria: groupFeedbcksByCategoria[prop].length,
                    feedbacks: arrayFeedbacksById,
                });
            }
            return arrayAux;
        },
        countFeedbacks(questao) {
            let countFeedbacks = 0;
            questao.resultados.map((resultado) => {
                resultado.anexos.map((anexo) => {
                    countFeedbacks += anexo.feedbacks_anexos.length;
                });
            });
            return countFeedbacks;
        },
        async manupulateData() {
            const vm = this;
            vm.dadosBar = null;
            vm.dadosBar = [];
            vm.labels = [];
            vm.dadosBar.push({
                name: "Aguardando Confirmação",
                type: "bar",
                stack: 10,
                label: { show: true, position: "insideRight" },
                data: [],
            });
            vm.dadosBar.push({
                name: "Válidas",
                type: "bar",
                stack: 10,
                label: { show: true, position: "insideRight" },
                data: [],
            });
            vm.dadosBar.push({
                name: "Inválidas",
                type: "bar",
                stack: 10,
                label: { show: true, position: "insideRight" },
                data: [],
            });

            _.map(vm.auditorias, (auditoria) => {
                vm.labels.push(auditoria.nomeAuditado);
                let filterResultado = _.filter(
                    auditoria.questoesAll,
                    "resultado",
                );
                let questoesAguardando = _.filter(filterResultado, q => q.resultado.status == 1).length;
                let questoesValidas = _.filter(filterResultado, q => q.resultado.status == 2).length;
                let questoesInvalidas = _.filter(filterResultado, q => q.resultado.status == 3).length;
                vm.dadosBar[0].data.push(questoesAguardando);
                vm.dadosBar[1].data.push(questoesValidas);
                vm.dadosBar[2].data.push(questoesInvalidas);
            });
        },
        async getAuditados() {
            const vm = this;
            try {
                vm.loadingAuditados = true;
                const response = await vm.$axios.get("/auditado", {
                    params: { ativo: 1 },
                });
                vm.listAuditados = response.data.rows || [];
                vm.loadingAuditados = false;
            } catch (error) {
                vm.loadingAuditados = false;
            }
        },
        async getQuestionarios() {
            const vm = this;
            try {
                vm.loading = true;
                const response = await vm.$axios.get("/questionario", {
                    params: { ativo: 1 },
                });
                vm.listQuestionarios = response.data.rows || [];
                vm.loading = false;
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao buscar os dados. Atualize a página!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loading = false;
            }
        },
        async getData() {
            const vm = this;
            vm.dadosbar = [];
            try {
                vm.loadingRelatorio = true;
                vm.auditorias = [];
                vm.documentos = [];
                const params = {
                    questionario_id: vm.filtro.questionario_id,
                    fields: "auditado,usuario,questionario,opcoes_questao",
                    data_inicial: this.$moment(vm.filtro.data_inicial).format("YYYY-MM-DD"),
                    data_final: this.$moment(vm.filtro.data_final).format("YYYY-MM-DD"),
                };
                if (vm.filtro.auditado_id) params.auditado_id = vm.filtro.auditado_id;
                if (vm.filtro.resultado_valor_status) params.resultado_valor_status = vm.filtro.resultado_valor_status;

                const response = await vm.$axios.get(`/auditoria-relatorio`, { params });

                _.map(response.data.rows, (auditoria) => {
                    vm.auditorias.push({
                        idAuditoria: auditoria.id,
                        idAuditado: auditoria.auditado.id,
                        nomeAuditado: auditoria.auditado.nome,
                        questoes: auditoria.questoes,
                        questoesFechadas: auditoria.questoesFechadas,
                        questoesAll: _.concat(auditoria.questoes, auditoria.questoesFechadas),
                        status: auditoria.status,
                        dataInicio: auditoria.data_inicio,
                        sumario: auditoria.sumario || null,
                    });
                    if (auditoria.documentos && auditoria.documentos.length) {
                        vm.documentos = vm.documentos.concat(auditoria.documentos);
                    }
                });
                if (vm.auditorias.length) {
                    vm.respostasPorAuditado = [];
                    vm.respostasAll = [];
                    vm.questoesExpandidas = {};
                    vm.manupulateData();
                    vm.createData();
                    vm.messageEmpty = false;
                    vm.$nextTick(() => { vm.loadingRelatorio = false; });
                } else {
                    vm.loadingRelatorio = false;
                    vm.auditorias = [];
                    vm.dadosBar = null;
                    vm.messageEmpty = true;
                }
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao buscar os dados. Atualize a página!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loadingRelatorio = false;
            }
        },
        customFilter(item, queryText, itemText) {
            const hasValue = (val) => (val != null ? val : "");
            const text = hasValue(item.nome || item.nomeAuditado);
            const query = hasValue(queryText);
            return (
                text
                    .toString()
                    .toLowerCase()
                    .indexOf(query.toString().toLowerCase()) > -1
            );
        },
    },
};
</script>

<style lang="scss" scoped>
#pageTable {
    background-color: #eeeeee;
}
</style>
